import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { SearchFilterContainer } from "./SearchFilterContainer";
import { Checkbox, FormControlLabel, FormGroup, Radio } from "@mui/material";
import { axiosFunction } from "../../commonFunctions";  
import { v2ReactURL } from "../../../utils/constant";
import { useSelector } from "react-redux";
import { customerTypes, supplierTypes } from "../../radioTypes/radioTypes";
import { ExtendedMemberType } from "../../../hooks/useContactRelatedApi";
import { CheckedValue } from "../../../pages/Contact/MainDataTable";





interface SearchFilterProps {
  index:number;
  isOpen: boolean;
  column: string;
  onFocus: () => void;
  checkedValue: CheckedValue ; 
  setCheckedValue: React.Dispatch<React.SetStateAction<CheckedValue>>;
  handleApplyFilterBtn: (callFilterselection?: boolean) => void;
  branchLocationList: Array<{ id: number ; name: string  ; userFrontId:number }>; // Adjust types based on actual data shape
  setOpenFilter?: React.Dispatch<React.SetStateAction<string | null>>;
  membershipList: Array<ExtendedMemberType>;
  setFilterData: React.Dispatch<React.SetStateAction<any[]>>;
  filterData: any[]; // Define the shape of filterData more specifically if possible
  handleSearch: (e: ChangeEvent<HTMLInputElement>, type: string) => void;
  contactFilteredIds: string[];
  setContactFilteredIds: React.Dispatch<React.SetStateAction<string[]>>;
  filteringData: Record<string, any>;
  setSearchInputValue: React.Dispatch<React.SetStateAction<string>>;
  searchInputValue: string;
}

const SearchFilter: React.FC<SearchFilterProps> = ({
  index,
  isOpen,
  column,
  onFocus,
  checkedValue,
  setCheckedValue,
  handleApplyFilterBtn,
  branchLocationList,
  setOpenFilter,
  membershipList,
  setFilterData,
  filterData,
  handleSearch,
  contactFilteredIds,
  filteringData,
  setSearchInputValue,
  searchInputValue,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const dropdownRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLInputElement>(null);
  // const sessionScope = useSelector((state: any) => state.sessionData.sessionScope);
  // const sessionBranchId = sessionScope?.branchId;
  // const sessionBranchId = 6439;
  // const sessionBranchId = 64;
  // const sessionBranchId = 5989;

  const [filterMsg, setFilterMsg] = useState<string>("Please Enter 3 Characters.");

  // Handle clicks outside of the dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        // setOpenFilter(null); // Close the dropdown
        // setCheckedValue({
        //   location: {
        //     [sessionBranchId]: {
        //       id: sessionBranchId,
        //       userFrontId: sessionBranchId,
        //     },
        //   },
        // });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setOpenFilter]);

  const idsName =
    column === "cityName"
      ? "city_id"
      : column === "stateName"
      ? "state_id"
      : column === "countryName"
      ? "country_id"
      : column === "createdByName"
      ? "userid"
      : column === "pinCode"
      ? "pin_code"
      : "contactIds";

  const resIdsName =
    column === "cityName"
      ? "cityIds"
      : column === "stateName"
      ? "stateIds"
      : column === "countryName"
      ? "countryIds"
      : column === "createdByName"
      ? "createdByIds"
      : column === "pinCode"
      ? "pincodes"
      : "contactIds";

  const labelsName =
    column === "cityName"
      ? "city_name"
      : column === "stateName"
      ? "state_name"
      : column === "countryName"
      ? "country_name"
      : column === "createdByName"
      ? "name"
      : column === "pinCode"
      ? "pin_code"
      : "data";

  const contactType = useSelector((state: any) => state.contactType);

  const contactPayloadData = useSelector((state: any) => state.contactPayloadData);

  const analyticsData = useSelector((state: any) => state.analyticsData);

  const customerType =
    contactType === "customers" ? customerTypes : supplierTypes;

  const statusList = [
    { value: "active", label: "Active" },
    { value: "deactive", label: "Inactive" },
  ];

  const mobNoVerifyList = [
    { value: "unVerified", label: "Un-verified" },
    { value: "verified", label: "Verified" },
  ];

   const gstTypeList = [
    { value: "UnRegistered", label: "UnRegistered" },
    { value: "Registered", label: "Registered" },
    { value: "Composition Scheme", label: "Composition Scheme" },
    { value: "Input Service Distributor", label: "Input Service Distributor" },
    { value: "E-Commerce Operator", label: "E-Commerce Operator" },
    { value: "UIN Holders", label: "UIN Holders" },
  ];

   const customerSegment = [
    { value: "Lost", label: "Lost" },
    { value: "Risk", label: "Risk" },
    { value: "Regular", label: "Regular" },
    { value: "VIP", label: "VIP" },
    { value: "ALL", label: "ALL" },
  ];
  

  const filterOutData = (obj: Record<string, any>, filterArr: any[]) => {
    // Convert the filter array to strings for easy comparison
    const filterSet = new Set(filterArr && filterArr?.map(String));

    const filteredObj =
      obj &&
      Object.entries(obj).reduce((acc, [key, value]) => {
        const contactIdsArray =
          value[idsName] &&
          value[idsName]
            .toString()
            .split(" ")
            .map((id: string) => id.trim());

        // Check if any contactIds exist in the filterArray
        if (
          contactIdsArray &&
          contactIdsArray.some((id: string) => filterSet.has(id.replace(",", "")))
        ) {
          acc[key] = value; // Add matching entry to the result
        }

        return acc;
      }, {}as Record<string, any>);

    return filteredObj;
  };
  const result =
      checkedValue && 
      column !== "active" &&
      column !== "isMobNoVerify" &&
      column !== "location" &&
      column !== "membershipName" &&
      column !== "contactType" &&
      checkedValue[column] &&
      filterOutData(checkedValue[column], filteringData[resIdsName]);

  const resultingArray = (result && Object.values(result)) || [];

 useEffect(() => {
   if (!isOpen) return; // only run if this is the open one
  setFilterData([]);
  setSearchInputValue("");
  setFilterMsg("Please Enter 3 Characters.");
}, [column, isOpen]);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const handleInputChange = async (e: ChangeEvent<HTMLInputElement>): Promise<void> =>{
    const searchValue: string = e.target.value.trim();
    setSearchInputValue(searchValue);
    setFilterData([]);
    let contactIds: string[] = [];
    Object.keys(checkedValue).forEach((field) => {
      if (field !== column) {
        // Only include contactIds if it's not the same field
        checkedValue[field] && Object.values(checkedValue[field]).forEach((item: any) => {
          return contactIds.push(item.contactIds);
        });
      }
    });

    let ids = contactIds.filter(
      (id) => id !== undefined && id !== null && id !== ""
    );
 

    const finalIds =
      Object.keys(checkedValue)?.length === 2 ? ids : contactFilteredIds;

    let urlEndpoint = "";
    if (column === "cityName") {
      urlEndpoint = `${v2ReactURL}/contact/${contactType}/filters/cityids`;
    } else if (column === "stateName") {
      urlEndpoint = `${v2ReactURL}/contact/${contactType}/filters/stateids`;
    } else if (column === "countryName") {
      urlEndpoint = `${v2ReactURL}/contact/${contactType}/filters/countryids`;
    } else if (column === "createdByName") {
      urlEndpoint = `${v2ReactURL}/contact/${contactType}/filters/username`;
    } else if (column === "pinCode") {
      urlEndpoint = `${v2ReactURL}/contact/${contactType}/filters/pincodes`;
    } else {
      urlEndpoint = `${v2ReactURL}/contact/${contactType}/filters/contactids`;
    }

    const {
      branchIds,
      cityIds,
      status,
      isMobNoVerify,
      membershipIds,
      contactType: contactTypes,
      createdByIds,
      pincodes,
    } = contactPayloadData;

    if (searchValue.length > 2) {
      const res = await axiosFunction(urlEndpoint, "POST", {
        key: column,
        searchValue: searchValue,
        status: status,
        isMobNoVerify: isMobNoVerify,
        branchIds: branchIds,
        membershipIds: membershipIds,
        contactType: contactTypes,
        contactIds: finalIds?.map((item) => item.split(",")).flat(),
        createdByIds: createdByIds,
        cityIds: cityIds,
        pincodes: pincodes,
        ...analyticsData,
        length: 200,
      });

      if (res?.data?.response?.length > 0) {
        const resData = res?.data?.response;
 
        const filteredRes = resData?.filter((rs:any) =>
          rs[labelsName].toLowerCase().includes(searchValue.toLowerCase())
        );
        setFilterMsg("");
        setFilterData(filteredRes);
      } else {
        setFilterData([]);
        setFilterMsg("No Records Found.");
      }
    } else {
      setFilterData([]);
      setFilterMsg("Please Enter 3 Characters.");
    }
  };

  const handleSelectAllData = () => {
    const allSelected = filterData?.reduce((acc, row) => {
      const ids =
        column === "cityName"
          ? row.city_id
          : column === "stateName"
          ? row.state_id
          : column === "countryName"
          ? row.country_id
          : column === "createdByName"
          ? row.userid
          : column === "pinCode"
          ? row.pin_code
          : row.contactIds;

      acc[ids] = row;
      return acc;
    }, {} as Record<number, any>);

    setCheckedValue((prev) => ({
      ...prev,
      [column]: {
        ...prev[column],
        ...allSelected,
      },
    }));
  };

  const handleSelectAllStatus = () => {
    const allStatus = statusList?.reduce((acc, status) => {
      acc[status.value] = status;
      return acc;
    }, {} as Record<string, any>);

    setCheckedValue((prev) => ({
      ...prev,
      [column]: allStatus,
    }));
  };

  const handleSelectAllGst = () => {
    const allStatus = gstTypeList?.reduce((acc, status) => {
      acc[status.value] = status;
      return acc;
    }, {} as Record<string, any>);

    setCheckedValue((prev) => ({
      ...prev,
      [column]: allStatus,
    }));
  };

  const handleSelectAllType = () => {
    const allSelected = customerType?.reduce((acc, type) => {
      acc[type.value] = type;
      return acc;
    }, {} as Record<string, any>);

    setCheckedValue((prev) => ({
      ...prev,
      [column]: allSelected,
    }));
  };

  const handleCheckFilterValue = (row:any) => {
    const ids =
      column === "cityName"
        ? row.city_id
        : column === "stateName"
        ? row.state_id
        : column === "countryName"
        ? row.country_id
        : column === "createdByName"
        ? row.userid
        : column === "pinCode"
        ? row.pin_code
        : row.contactIds;

    setCheckedValue((prev) => {
      const isChecked = prev[column]?.[ids];

      if (isChecked) {
        // If the value is unchecked, remove it from the column
        const { [ids]: _, ...rest } = prev[column] || {};

        // Check if the column has any remaining items, if not, remove the entire column
        if (Object.keys(rest).length === 0) {
          const { [column]: __, ...remainingColumns } = prev;
          return remainingColumns;
        } else {
          return { ...prev, [column]: rest };
        }
      } else {
        // If the value is being checked, add it to the column
        return {
          ...prev,
          [column]: {
            ...prev[column],
            [ids]: row,
          },
        };
      }
    });
  };

  const handleCheckStatusFilter = (row:any) => {
    setCheckedValue((prev) => {
      const isChecked = prev[column]?.[row.value];

      if (isChecked) {
        const { [row.value]: _, ...rest } = prev[column]|| {};
        return { ...prev, [column]: rest };
      } else {
        return {
          ...prev,
          [column]: {
            ...prev[column],
            [row.value]: row,
          },
        };
      }
    });
  };
  const handleCheckGstFilter = (row:any) => {
    setCheckedValue((prev) => {
      const isChecked = prev[column]?.[row.value];

      if (isChecked) {
        const { [row.value]: _, ...rest } = prev[column]|| {};
        return { ...prev, [column]: rest };
      } else {
        return {
          ...prev,
          [column]: {
            ...prev[column],
            [row.value]: row,
          },
        };
      }
    });
  };
  const handleCustomerSegmentChange = (row:any) => {
    setCheckedValue((prev) => {
      const isChecked = prev[column]?.[row.value];

      if (isChecked) {
        const { [row.value]: _, ...rest } = prev[column]|| {};
        return { ...prev, [column]: rest };
      } else {
        return {
          ...prev,
          [column]: {
            ...prev[column],
            [row.value]: row,
          },
        };
      }
    });
  };

  const handleDynamicFilter = (row:any) => {
    setCheckedValue((prev) => {
      const isChecked = prev[column]?.[row.id];

      if (isChecked) {
        const { [row.id]: _, ...rest } = prev[column]|| {};
        return { ...prev, [column]: rest };
      } else {
        return {
          ...prev,
          [column]: {
            ...prev[column],
            [row.id]: row,
          },
        };
      }
    });
  };

  const handleDynamicSelectAllFilter = (type:string) => {
    const filterTypeList =
      type === "location" ? branchLocationList : membershipList;
    const allSelected = filterTypeList?.reduce((acc, row) => {
      acc[row.id] = row;

      return acc;
    }, {} as Record<string, any>);

    setCheckedValue((prev) => ({
      ...prev,
      [column]: allSelected,
    }));
  };

  const isChecked = (contactId:number) => {
    return !!checkedValue[column]?.[contactId];
  };

  const isStatusChecked = (value:string) => {
    return column === "active"
      ? !!checkedValue["active"]?.[value]
      : !!checkedValue["isMobNoVerify"]?.[value];
  };

  const isCustomerTypeChecked = (value:string) => {
    return !!checkedValue["contactType"]?.[value];
  };

  const isGstChecked = (value:string) => {
    return !!checkedValue["gstType"]?.[value];
  };

 
  return (
    <td key={index} className="filter-design" style={{ borderRight: 0 }}>
      <SearchFilterContainer ref={containerRef}>
        {isOpen &&
          column !== "active" &&
          column !== "totalSales" &&
          column !== "gstType" &&
          column !== "isMobNoVerify" &&
          column !== "contactType" && (
            <input
              ref={inputRef}
              className="input-search"
              type="text"
              style={{
                display: true ? "block" : "none",
              }}
              onFocus={onFocus}
              onChange={
                column === "location"
                  ? (e) => handleSearch(e, "branch")
                  : column === "membershipName"
                  ? (e) => handleSearch(e, "membership")
                  : (e) => handleInputChange(e)
              }
            />
          )}

        {isOpen &&
          column !== "active" &&
          column !== "isMobNoVerify" &&
          column !== "gstType" &&
          column !== "totalSales" &&
          column !== "location" &&
          column !== "membershipName" &&
          column !== "contactType" && (
            <div ref={dropdownRef} className="customSearchModel">
              <div>
                <ul>
                  {result &&
                    resultingArray
                      ?.filter((rarray) =>
                        rarray[labelsName]
                          .toLowerCase()
                          .includes(searchInputValue.toLowerCase())
                      )
                      ?.map((l) => {
                        return (
                          <li key={l[idsName]}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    onChange={() => handleCheckFilterValue(l)}
                                    checked={isChecked(l[idsName])}
                                  />
                                }
                                label={l[labelsName]}
                              />
                            </FormGroup>
                          </li>
                        );
                      })
                      }

                  {filterData?.length > 0 &&
                    filterData
                      ?.filter(
                        (col) =>
                          !resultingArray?.some(
                            (col1) => col1[idsName] == col[idsName]
                          )
                      )
                      ?.map((label) => {
                        const ids =
                          column === "cityName"
                            ? label.city_id
                            : column === "stateName"
                            ? label.state_id
                            : column === "countryName"
                            ? label.country_id
                            : column === "createdByName"
                            ? label.userid
                            : column === "pinCode"
                            ? label.pin_code
                            : label.contactIds;

                        const labels =
                          column === "cityName"
                            ? label.city_name
                            : column === "stateName"
                            ? label.state_name
                            : column === "countryName"
                            ? label.country_name
                            : column === "createdByName"
                            ? label.name
                            : column === "pinCode"
                            ? label.pin_code
                            : label.data;

                        return (
                          <li key={ids}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    onChange={() =>
                                      handleCheckFilterValue(label)
                                    }
                                    checked={isChecked(ids)}
                                  />
                                }
                                label={labels}
                              />
                            </FormGroup>
                          </li>
                        );
                      })}

                  <div>{filterMsg}</div>

                  {/* {renderList()} */}
                </ul>
                <div className="SearchFilterModelFooter">
                  <div>
                    <button
                      disabled={filterData?.length === 0}
                      style={{
                        cursor:
                          filterData?.length === 0 ? "not-allowed" : "pointer",
                        border: "none",
                      }}
                      onClick={handleSelectAllData}
                      className="text-btn"
                    >
                      Select All
                    </button>
                  </div>
                  <div>
                    <button
                      // disabled={resultingArray === undefined}
                      style={{
                        // cursor:
                        //   resultingArray.length === 0
                        //     ? "not-allowed"
                        //     : "pointer",
                        border: "none",
                      }}
                      onClick={() => handleApplyFilterBtn()}
                      className="text-btn kp-btn"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

        {isOpen && column === "active" && (
          <div
            ref={dropdownRef}
            style={{ width: "130px", top: "10px" }}
            className="customSearchModel"
          >
            <div>
              <ul>
                {statusList?.map((label) => {
                  return (
                    <li key={label.value}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={() => handleCheckStatusFilter(label)}
                              checked={isStatusChecked(label.value)}
                            />
                          }
                          label={label.label}
                        />
                      </FormGroup>
                    </li>
                  );
                })}
              </ul>
              <div className="SearchFilterModelFooter">
                <div>
                  <span onClick={handleSelectAllStatus} className="text-btn">
                    Select All
                  </span>
                </div>
                <div>
                  <span
                    onClick={() => handleApplyFilterBtn(false)}
                    className="text-btn"
                  >
                    Apply
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {isOpen && column === "isMobNoVerify" && (
          <div
            ref={dropdownRef}
            style={{ width: "150px", top: "10px" }}
            className="customSearchModel"
          >
            <div>
              <ul>
                {mobNoVerifyList?.map((label) => {
                  return (
                    <li key={label.value}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={() => handleCheckStatusFilter(label)}
                              checked={isStatusChecked(label.value)}
                            />
                          }
                          label={label.label}
                        />
                      </FormGroup>
                    </li>
                  );
                })}
              </ul>
              <div className="SearchFilterModelFooter">
                <div>
                  <span onClick={handleSelectAllStatus} className="text-btn">
                    Select All
                  </span>
                </div>
                <div>
                  <span
                    onClick={() => handleApplyFilterBtn(false)}
                    className="text-btn"
                  >
                    Apply
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {isOpen && column === "gstType" && (
          <div
            ref={dropdownRef}
            style={{ width: "150px", top: "10px" }}
            className="customSearchModel"
          >
            <div>
              <ul>
                {gstTypeList?.map((label) => {
                  return (
                    <li key={label.value}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={() => handleCheckGstFilter(label)}
                              checked={isGstChecked(label.value)}
                            />
                          }
                          label={label.value}
                        />
                      </FormGroup>
                    </li>
                  );
                })}
              </ul>
              <div className="SearchFilterModelFooter">
                <div>
                  <span onClick={handleSelectAllGst} className="text-btn">
                    Select All
                  </span>
                </div>
                <div>
                  <span
                    onClick={() => handleApplyFilterBtn(false)}
                    className="text-btn"
                  >
                    Apply
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

          {isOpen && column === "totalSales" && (
          <div
            ref={dropdownRef}
            style={{ width: "150px", top: "10px" }}
            className="customSearchModel"
          >
            <div>
              <ul>
                {customerSegment?.map((label) => {
                  return (
                    <li key={label.value}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Radio
                              onChange={() => handleCustomerSegmentChange(label)}
                            />
                          }
                          label={label.value}
                        />
                      </FormGroup>
                    </li>
                  );
                })}
              </ul>
              <div className="SearchFilterModelFooter">
                <div>
                  {/* <span onClick={handleSelectAllGst} className="text-btn">
                    Select All
                  </span> */}
                </div>
                <div>
                  <span
                    onClick={() => handleApplyFilterBtn(false)}
                    className="text-btn"
                  >
                    Apply
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {isOpen && column === "location" && (
          <div
            ref={dropdownRef}
            style={{ width: "100%" }}
            className="customSearchModel"
          >
            <div>
              <ul>
                {branchLocationList?.map((label) => {
                  return (
                    <li key={label.id}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={() => handleDynamicFilter(label)}
                              checked={isChecked(label.id)}
                            />
                          }
                          label={label.name}
                        />
                      </FormGroup>
                    </li>
                  );
                })}
              </ul>
              <div className="SearchFilterModelFooter">
                <div>
                  <span
                    onClick={() => handleDynamicSelectAllFilter("location")}
                    className="text-btn"
                  >
                    Select All
                  </span>
                </div>
                <div>
                  <span
                    onClick={() => handleApplyFilterBtn()}
                    className="text-btn"
                  >
                    Apply
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {isOpen && column === "membershipName" && (
          <div
            ref={dropdownRef}
            style={{ width: "100%" }}
            className="customSearchModel"
          >
            <div>
              <ul>
                {membershipList?.map((label) => {
                  return (
                    <li key={label.id}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={() => handleDynamicFilter(label)}
                              checked={isChecked(label.id)}
                            />
                          }
                          label={label.name}
                        />
                      </FormGroup>
                    </li>
                  );
                })}
              </ul>
              <div className="SearchFilterModelFooter">
                <div>
                  <span
                    onClick={() =>
                      handleDynamicSelectAllFilter("membershipName")
                    }
                    className="text-btn"
                  >
                    Select All
                  </span>
                </div>
                <div>
                  <span
                    onClick={() => handleApplyFilterBtn()}
                    className="text-btn"
                  >
                    Apply
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {isOpen && column === "contactType" && (
          <div
            ref={dropdownRef}
            style={{ width: "150px", top: "10px" }}
            className="customSearchModel"
          >
            <div>
              <ul>
                {customerType?.map((label) => {
                  return (
                    <li key={label.value}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={() => handleCheckStatusFilter(label)}
                              checked={isCustomerTypeChecked(label.value)}
                            />
                          }
                          label={label.label}
                        />
                      </FormGroup>
                    </li>
                  );
                })}
              </ul>
              <div className="SearchFilterModelFooter">
                <div>
                  <span onClick={handleSelectAllType} className="text-btn">
                    Select All
                  </span>
                </div>
                <div>
                  <span
                    onClick={() => handleApplyFilterBtn(false)}
                    className="text-btn"
                  >
                    Apply
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </SearchFilterContainer>
    </td>
  );
};

export default SearchFilter;
